export const locales = {
    "au": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "nz": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "ca": {
        "language": [
            { "code": "en", "name": "English", "default": true },
            { "code": "fr", "name": "Français" }
        ]
    },
    "us": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "uk": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "ie": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "fr": {
        "language": [
            { "code": "fr", "name": "Français", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "ch": {
        "language": [
            { "code": "de", "name": "Deutsch", "default": true },
            { "code": "fr", "name": "Français" },
            { "code": "en", "name": "English" }
        ]
    },
    "de": {
        "language": [
            { "code": "de", "name": "Deutsch", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "nl": {
        "language": [
            { "code": "nl", "name": "Nederlands", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "es": {
        "language": [
            { "code": "es", "name": "Español", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "no": {
        "language": [
            { "code": "nb", "name": "Norsk bokmål", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "se": {
        "language": [
            { "code": "sv", "name": "Svenska", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "dk": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "eu": {
        "language": [
            { "code": "en", "name": "English", "default": true },
            { "code": "de", "name": "Deutsch" },
            { "code": "es", "name": "Español" },
            { "code": "fr", "name": "Français" }
        ]
    },
    "cz": {
        "language": [
            { "code": "cs", "name": "Čeština", "default": true },
            { "code": "en", "name": "English" }
        ]
    },
    "sg": {
        "language": [{ "code": "en", "name": "English", "default": true }]
    },
    "ex": {
        "language": [
            { "code": "en", "name": "English", "default": true },
            { "code": "es", "name": "Español" },
            { "code": "fr", "name": "Français" }
        ]
    }
}


export const hreflangStandardCodes = {
    "en-uk": "en-gb",
    "en-eu": "en",
    "de-eu": "de",
    "fr-eu": "fr",
    "es-eu": "es",
    "en-ex": "en",
    "es-ex": "es",
    "fr-ex": "fr"
}
